import React from "react";
import { localstorageKeys } from "@const/store";
import { ReactComponent as TwitterIconDark } from "../../assets/ic-twitter-x.svg";
import { ReactComponent as TwitterIconLight } from "../../assets/ic-twitter-x-light.svg";
import { useService } from "@/base/hooks/useService";
import { StorageService } from "@services/StorageService";

const TwitterIcon = ({ oppositeColor, ...props }) => {
  const storageService = useService(StorageService);

  const theme = storageService.get(localstorageKeys.theme, "");

  if (oppositeColor) {
    return theme === "light" ? (
      <TwitterIconDark {...props} />
    ) : (
      <TwitterIconLight {...props} />
    );
  }

  return theme === "dark" ? (
    <TwitterIconDark {...props} />
  ) : (
    <TwitterIconLight {...props} />
  );
};

export default TwitterIcon;
